import { Divider } from '@mui/material';
import { action, computed, makeObservable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import { InView } from 'react-intersection-observer';
import ReactComponent from '../ReactComponent';
import CabecalhoProcessoOperacoesEmLotePartes from './CabecalhoProcessoOperacoesEmLotePartes';

class PainelProcessoOperacoesEmLotePartes extends ReactComponent {
    timeoutRender;

    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            processo: computed,
            partes: computed,
            handleChangeObserver: action,
            renderCabecalho: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    get partes() {
        return this.observableProps.partes;
    }

    handleChangeObserver = (inView) => {
        if (this.timeoutRender) {
            clearTimeout(this.timeoutRender);
        }
        this.timeoutRender = setTimeout(
            () =>
                runInAction(() => {
                    this.registro.renderedOperacoesEmLote = inView;
                }),
            inView ? 50 : 500
        );
    };

    componentWillUnmount() {
        super.componentWillUnmount();
        if (this.timeoutRender) {
            clearTimeout(this.timeoutRender);
        }
    }

    render() {
        return (
            <Fragment>
                <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }} />
                <InView
                    as="div"
                    onChange={this.handleChangeObserver}
                    rootMargin="1000px 0px"
                    root={this.observableProps.scrollRoot}
                >
                    {this.renderCabecalho}
                </InView>
            </Fragment>
        );
    }

    get renderCabecalho() {
        return this.registro.renderedOperacoesEmLote ? (
            <CabecalhoProcessoOperacoesEmLotePartes
                registro={this.registro}
                partes={this.partes}
                {...this.observableProps}
            />
        ) : (
            <div style={{ display: 'flex', alignItems: 'center', height: '40px', paddingLeft: '20px' }}>
                Carregando {this.registro.processo.numeroCompleto}...
            </div>
        );
    }
}

export default inject('stores')(observer(PainelProcessoOperacoesEmLotePartes));
